<template>
  <el-form-item
    v-if="field && !blocked"
    v-bind="$attrs"
    :prop="field.name"
    :class="[
      'row',
      field.readonly ? 'is-readonly' : '',
      field.background ? 'with-background' : '',
      field.buttons ? 'row--with-btn' : '',
      field.name == 'currency_id' ? 'currency__input' : '',
      field.name == 'superjob_covid' ? 'column-radio__block' : '',

      isEmptyField(field, model) ? 'is-empty-field' : '',
      field.visual_type === 'radiobutton' ? 'radio__block' : ''
    ]"
    :style="`${
      field.background && field.background['background-color']
        ? `background-color: ${field.background['background-color']};`
        : ''
    }`"
  >
    <span
      v-if="
        field.type !== FIELD.TYPE.BOOL &&
        field.visual_type !== 'no-label' &&
        field.visual_type !== 'radiobutton'
      "
      v-tooltip
      class="el-form-item__label"
      :class="{
        currency__input: field.name == 'currency_id',
        'date-label-start': field.name == 'date_start',
        'date-label-end': field.name == 'date_end',
        'no-required-star':
          field.visual_type == 'no-required-star' || noRequiredStar
      }"
      :style="`line-height: ${
        fieldSize == 'big' ? 40 : fieldSize == 'medium' ? 32 : 24
      }px`"
    >
      {{ newLabel || field.lbl }}
      <p v-if="field.help && field.icon_help" class="help__text">
        {{ field.help | format }}
      </p>
      <p v-if="field.required" class="required-star">*</p>
      <Tooltip
        v-if="field.help_label && field.help_label.icon"
        :content="field.help_label.text"
        class="p-2"
      >
        <Icon iconName="question-circle" iconColor="#0075DB" />
      </Tooltip>
    </span>
    <!-- <span class="el-form-item__label" v-if="field.type === FIELD.TYPE.BOOL && field.name =='external_customer'">
     <br>
    </span> -->
    <DatePicker
      v-if="dateType(field.type) && !timePickerField"
      :field="{
        ...field,
        disabled: visibilityBlocked
      }"
      :model="model"
      :datepicker="datepicker"
      :size="fieldSize"
      :options="pickerOptions[field.name] || {}"
      :callback="callback"
      @set-value="(...params) => setValue(...params, null, true)"
    ></DatePicker>
    <TimePicker
      v-else-if="field.type == FIELD.TYPE.DATETIME && timePickerField"
      :model="model"
      :field="{
        ...field,
        disabled: visibilityBlocked
      }"
      :options="{
        start: '00:00',
        end: '23:30',
        step: '00:30'
      }"
      @set-value="(...params) => setValue(...params, null, true)"
    />
    <Alert
      v-else-if="field.type === FIELD.TYPE.ALERT"
      :text="model && model.text ? model.text : field.value ? field.value : ''"
      :url="model && model.link && model.link.value ? model.link : ''"
      :class="{ 'export-alert': field.name == 'sub_text_save_resume' }"
    />
    <form
      v-else-if="field.type === FIELD.TYPE.FILE"
      id="upload-doc"
      enctype="multipart/form-data"
    >
      <Upload
        v-loading="addFile_loading"
        name="filename_file"
        :file="filename_file"
        :multiple="true"
        :show-file-list="false"
        uploadText="Перетащите сюда любой документ"
        class="form__upload"
        @upload-file="uploadDocument"
      ></Upload>
    </form>
    <div
      v-else-if="
        field.type == FIELD.TYPE.ENUM &&
        field.visual_type === 'radiobutton' &&
        field.name == 'resume_format'
      "
      class="form-format"
    >
      <p class="form-format__title">{{ field.lbl }}</p>
      <div class="form-format__radio" :name="field.name">
        <Radio
          v-for="(val, key) in field.options"
          :key="key"
          :label="key"
          :model="model"
          :text="val"
          :class="isEmptyField(field, model) && clickSaveForm && 'is-error'"
          @set-value="val => setValue(field.name, val, field.blocked)"
        />
      </div>
    </div>
    <div
      v-else-if="
        field.type == FIELD.TYPE.ENUM &&
        field.visual_type === 'radiobutton' &&
        field.name == 'action'
      "
      class="form-format__radio-text"
    >
      <p
        class="el-form-radio__label"
        :style="`line-height: ${
          fieldSize == 'big' ? 40 : fieldSize == 'medium' ? 32 : 24
        }px`"
      >
        {{ field.lbl }}
      </p>
      <div :name="field.name">
        <Radio
          v-for="(val, key) in field.options"
          :key="key"
          :label="key"
          :model="model"
          :text="val"
          :class="isEmptyField(field, model) && clickSaveForm && 'is-error'"
          @set-value="val => setValue(field.name, val, field.blocked)"
        />
      </div>
    </div>
    <template
      v-else-if="
        field.type == FIELD.TYPE.ENUM && field.visual_type === 'radiobutton'
      "
    >
      <div
        v-tooltip
        class="el-form-item__label"
        :class="{
          'no-required-star':
            field.visual_type == 'no-required-star' ||
            noRequiredStar ||
            !field.required
        }"
        :style="`line-height: ${
          fieldSize == 'big' ? 40 : fieldSize == 'medium' ? 32 : 24
        }px`"
      >
        {{ newLabel || field.lbl }}
        <p v-if="field.required" class="required-star">*</p>
      </div>
      <div :style="field.next_line ? '' : 'display: flex'" :name="field.name">
        <Radio
          v-for="(val, key) in field.options"
          :key="key"
          :label="key"
          :model="model"
          :text="val"
          :class="isEmptyField(field, model) && clickSaveForm && 'is-error'"
          @set-value="val => setValue(field.name, val, field.blocked)"
        />
      </div>
    </template>
    <div v-else-if="specializField && field.visual_type">
      <Dropdown
        :field="field"
        :model="categoryModel"
        :options="options"
        :callback="callback"
        :loading="loading"
        :size="fieldSize"
        :specializField="specializField"
        :defaultFirstOption="defaultFirstOption"
        :blockedOptionsByOtherField="blockedOptionsByOtherField"
        @set-value="setValue"
        @change-option="selectOption"
        @add-new-option="addNewOption"
      ></Dropdown>
      <div
        v-if="fieldValue[0] && field.visual_type == 'sub_checkbox'"
        class="specializations-tags"
      >
        <Tag
          v-for="tag in tags"
          :key="tag.index"
          :id="tag.index"
          @close="deleteTag(tag)"
          size="small"
          :closable="true"
          :name="tag.name"
        />
      </div>
      <div
        v-else-if="categoryModel && field.visual_type == 'sub_checkbox'"
        class="specializations-tags"
      >
        <Tag
          v-for="tag in model"
          :key="tag"
          :id="tag"
          @close="deleteDraftTag(tag)"
          size="small"
          :closable="true"
          :name="
            specializations[categoryModel[0]] &&
            specializations[categoryModel[0]].specializations[tag]
              ? specializations[categoryModel[0]].specializations[tag]
              : specializations[categoryModel[1]] &&
                specializations[categoryModel[1]].specializations[tag]
              ? specializations[categoryModel[1]].specializations[tag]
              : specializations[categoryModel[2]] &&
                specializations[categoryModel[2]].specializations[tag]
              ? specializations[categoryModel[2]].specializations[tag]
              : specializations[categoryModel[3]] &&
                specializations[categoryModel[3]].specializations[tag]
              ? specializations[categoryModel[3]].specializations[tag]
              : specializations[categoryModel[4]] &&
                specializations[categoryModel[4]].specializations[tag]
              ? specializations[categoryModel[4]].specializations[tag]
              : '0'
          "
        />
      </div>
      <div
        v-show="
          (fieldValue[0] || categoryModel[0]) &&
          field.visual_type == 'sub_checkbox'
        "
        v-if="field.label == 'LBL_SPECIALIZATIONS_RABOTARU'"
        style="margin: 12px 0; line-height: 24px; display: flex"
        class="rabota-ru-lbl"
      >
        <span><Icon iconName="Warning" /></span>
        <span>{{
          'Можно выбрать до пяти профессиональных сфер во всех категориях'
        }}</span>
      </div>
      <p
        v-else
        v-show="
          (fieldValue[0] || categoryModel[0]) &&
          field.visual_type == 'sub_checkbox'
        "
        style="margin: 12px 0; line-height: 24px"
      >
        {{ 'Выберите не более 5 специализаций' }}
      </p>

      <div
        v-if="
          (Array.isArray(fieldValue) && fieldValue.length) ||
          (fieldValue.length && field.visual_type == 'sub_radio')
        "
        class="specializations-block"
      >
        <div v-if="field.visual_type == 'sub_checkbox'" style="column-count: 2">
          <CheckboxGroup
            :elements="
              specializations[fieldValue[fieldValue.length - 1]].specializations
            "
            :trueValue="trueValueCheckbox"
            :max="5"
            @change="checkSpecial"
          />
        </div>
        <div
          v-if="field.visual_type == 'sub_radio'"
          style="column-count: 2"
          :name="field.name"
        >
          <Radio
            v-for="(name, index) in specializations[fieldValue].specializations"
            :key="index"
            :label="index"
            :model="model"
            :text="name"
            :class="isEmptyField(field, model) && clickSaveForm && 'is-error'"
            @set-value="setRadioValue(FIELD.ID.SPECIALIZATIONS, index)"
            class="radio-group"
          />
        </div>
        <Button
          v-if="field.visual_type == 'sub_checkbox'"
          buttonSize="big"
          hasLeftIcon
          :disabled="
            checkSpecializations.length < 1 ||
            (tags.length == 5 && model.length < 6)
          "
          iconName="Plus-bold"
          buttonColor="blue"
          :buttonText="
            field.label == 'LBL_SPECIALIZATIONS_RABOTARU'
              ? 'Добавить профессиональные сферы'
              : 'Добавить специализации'
          "
          @click="addSpecial"
        />
      </div>
      <div
        v-else-if="categoryModel && model.length > 0"
        class="specializations-block"
      >
        <div v-if="field.visual_type == 'sub_checkbox'" style="column-count: 2">
          <!-- <p>{{ model }}</p>
          <p>{{ categoryModel }}</p>
          <p>{{ specializations[categoryModel[0]] }}</p> -->

          <CheckboxGroup
            :elements="
              categoryModel.length >= 1 &&
              specializations[categoryModel[categoryModel.length - 1]] &&
              specializations[categoryModel[categoryModel.length - 1]]
                .specializations
            "
            :trueValue="(trueValueCheckbox = draftCheckboxData)"
            :max="5"
            @change="checkSpecial"
          />
        </div>
        <div
          v-if="field.visual_type == 'sub_radio'"
          style="column-count: 2"
          :name="field.name"
        >
          <Radio
            v-for="(name, index) in specializations[categoryModel]
              .specializations"
            :key="index"
            :label="index"
            :model="Array.isArray(model) ? model[0] : model"
            :text="name"
            :class="isEmptyField(field, model) && clickSaveForm && 'is-error'"
            @set-value="setRadioValue(FIELD.ID.SPECIALIZATIONS, index)"
          />
        </div>
        <Button
          v-if="field.visual_type == 'sub_checkbox' && model"
          buttonSize="big"
          hasLeftIcon
          :disabled="checkSpecializations.length < 1 || tags.length == 5"
          iconName="Plus-bold"
          buttonColor="blue"
          :buttonText="
            field.label == 'LBL_SPECIALIZATIONS_RABOTARU'
              ? 'Добавить профессиональные сферы'
              : 'Добавить специализации'
          "
          class="no_model"
          @click="addSpecial"
        />
      </div>
    </div>
    <template
      v-else-if="selectType(field.type) && field.visual_type != 'multi-level'"
    >
      <p
        v-if="
          field.name === 'new_specializations' && field['multiple-limit'] === 1
        "
        style="margin-bottom: 12px; line-height: 24px"
      >
        {{ 'Выберите не более 1 специализации' }}
      </p>
      <Dropdown
        :field="field"
        :model="
          hidden(field)
            ? 'Недоступно для редактирования'
            : field.name == 'areas'
            ? areasModel
            : model
        "
        :options="
          field.type == FIELD.TYPE.RELATE ||
          field.type == FIELD.TYPE.RELLINK ||
          field.subtype == FIELD.TYPE.RELLINK
            ? newOptions
            : field.type == FIELD.TYPE.ENUM && field.option_blocking_parent
            ? filteredOptionsByBlockingParent
            : options
        "
        @load-more="
          (str, method) => setNewOptions(str, method, field.paginationUrl)
        "
        :reserve-keyword="field.type == FIELD.TYPE.RELLINK ? true : false"
        :callback="callback"
        :loading="loading"
        :visible-option-btn="visibleOptionBtn"
        :visibleLoadMoreBtn="loadMoreNum == 50"
        :parentenum="parentenum"
        :clearable="clearable && field.name != 'status'"
        create-btn-text="Добавить"
        :size="fieldSize"
        :class="[field.name == FIELD.ID.CURRENCY_ID ? 'currency__input' : '']"
        :defaultFirstOption="defaultFirstOption"
        :blockedOptionsByOtherField="blockedOptionsByOtherField"
        :no-tags="noTags"
        @set-value="setValue"
        @change-option="selectOption"
        @change-rellink-option="changeRellinkOption"
        @add-new-option="addNewOption"
        @filter-option="
          (str, method) => filterOptions(str, method, field.paginationUrl)
        "
      />
    </template>
    <MultiLevelSelect
      v-else-if="
        field.type == FIELD.TYPE.RELATE && field.visual_type == 'multi-level'
      "
      :field="field"
      :model="
        hidden(field)
          ? 'Недоступно для редактирования'
          : form[field.id_name.name]
      "
      :label="model"
      :options="newOptions"
      :callback="callback"
      :size="field.background ? 'medium' : fieldSize"
      :module="module"
      :clearable="true"
      @set-value="setValue"
      @change-option="selectOption"
      @load-more="
        (str, method) => setNewOptions(str, method, field.paginationUrl)
      "
      @filter-option="
        (str, method) => filterOptions(str, method, field.paginationUrl)
      "
    />
    <InputMasked
      v-else-if="field.mask"
      :field="{
        ...field,
        disabled: visibilityBlocked
      }"
      :model="model"
      :mask="field.mask"
      :masked="true"
      :phone-input="phoneField"
      :callback="callback"
      :size="fieldSize"
      @set-value="(...params) => setValue(...params, null, true)"
    ></InputMasked>
    <InputMasked
      v-else-if="salaryField"
      :field="{
        ...field,
        disabled: visibilityBlocked
      }"
      :model="model"
      :mask="[
        '### ',
        '# ###',
        '## ###',
        '### ### ',
        '# ### ###',
        '## ### ###',
        '### ### ###'
      ]"
      :phone-input="phoneField"
      :callback="callback"
      :size="fieldSize"
      @set-value="(...params) => setValue(...params, null, true)"
    ></InputMasked>
    <InputMasked
      v-else-if="phoneField"
      :field="{
        ...field,
        disabled: visibilityBlocked
      }"
      :model="model"
      :phone-input="phoneField"
      :mask="[
        '+#######',
        '+########',
        '+#########',
        '+##########',
        '+###########',
        '+############',
        '+#############',
        '+##############',
        '+###############'
      ]"
      :callback="callback"
      :size="fieldSize"
      @set-value="(...params) => setValue(...params, null, true)"
    />
    <InputMasked
      v-else-if="field.name == FIELD.ID.CONTACTS_ADDITIONAL_PHONES"
      :field="field"
      :model="model"
      :mask="['#', '##', '###', '####', '#####', '######']"
      :phoneType="false"
      :callback="callback"
      :size="fieldSize"
      @set-value="(...params) => setValue(...params, null, true)"
    />
    <CustomCheckbox
      v-else-if="
        field.type === FIELD.TYPE.BOOL && field.visual_type != 'switcher'
      "
      :disabled="disabled(field) || field.disabled"
      :name="field.name"
      :text="field.lbl"
      :value="Number(model)"
      :required="field.required"
      @change="
        val => setValue(field.name, String(+val), field.blocked, null, true)
      "
    >
    </CustomCheckbox>
    <Switcher
      v-else-if="switcherField(field)"
      :model="model == '0' || !model ? false : true"
      :disabled="disabled(field) || field.disabled"
      :name="field.name"
      :required="field.required"
      :active-text="field.lbl"
      :size="field.name == 'self_response' ? 'big' : 'medium'"
      @switch="
        val =>
          setValue(
            field.name,
            field.required && !val ? '' : String(+val),
            field.blocked,
            null,
            true
          )
      "
    />
    <Input
      v-else-if="hidden(field)"
      :field="{
        ...field,
        disabled: visibilityBlocked
      }"
      model="Недоступно для редактирования"
      :disabled="true"
      :readonly="true"
      :size="fieldSize"
    />
    <!-- <Input v-else-if="field.name == 'currency_id'" class="currency__input"  :field="field" :model="model" @set-value="setValue" /> -->
    <span v-else-if="field.type === 'stringText'" class="stringText">{{
      field.value
    }}</span>

    <div v-else-if="field.type === 'group_checkbox'" style="column-count: 1">
      <CustomCheckboxGroup
        :elements="field.options"
        :model="model || []"
        :type="field.visual_type"
        @change="val => setValue(field.name, val)"
      />
    </div>
    <div
      v-else-if="field.type === 'stringHtml'"
      class="full-resume"
      v-html="model"
    ></div>

    <Input
      v-else
      :field="
        field.name.indexOf('password') != -1
          ? { ...field, htmlType: 'password' }
          : { ...field, disabled: visibilityBlocked }
      "
      :model="String(model || field?.value || '')"
      :size="fieldSize"
      :callback="callback"
      :disabled="disabled"
      @set-value="(...params) => setValue(...params, null, true)"
    />
    <template v-if="field['help-bottom']">
      <Link
        v-if="field['help-bottom']?.link"
        class="help__text"
        :style="`color: ${field['help-bottom']?.color || '#21272c'}`"
        :text="field['help-bottom']?.text"
        target="_blank"
        :href="field['help-bottom']?.link"
      />
      <p
        v-else
        v-html="field['help-bottom']?.text"
        class="help__text"
        :style="`color: ${field['help-bottom']?.color || '#21272c'}`"
      ></p>
    </template>
  </el-form-item>
</template>
<script>
import { FormItem } from 'element-ui';
import { form, mixin } from '@/utils/mixins';
import { FIELD, MODULE, ACTION } from '@/utils/constants';
import DatePicker from 'Elements/DatePicker/DatePicker';
import TimePicker from 'Elements/TimePicker/TimePicker';
import Dropdown from 'Elements/Select/Dropdown';
import MultiLevelSelect from 'Elements/Select/MultiLevelSelect';
import Input from 'Elements/Input/Input';
import InputMasked from 'Elements/Input/InputMasked';
import Radio from 'Elements/Radio/Radio';
import CustomCheckbox from 'Elements/Checkbox/CustomCheckbox';
import CheckboxGroup from 'Elements/Checkbox/CheckboxGroup';
import CustomCheckboxGroup from 'Elements/Checkbox/CustomCheckboxGroup';
import Switcher from 'Elements/Switch/Switch';
import Button from 'Elements/Button/Button';
import Tag from 'Elements/Tag/Tag';
import Alert from 'Elements/Alert/Alert';
import { getController, postController } from '@/controllers/request.js';
import { store } from '@/store';
import Upload from 'Elements/Upload/Upload';
import Tooltip from 'Elements/Tooltip/Tooltip';
import Icon from 'Elements/Icon/Icon';
import Link from 'Elements/Link/Link';

export default {
  mixins: [form, mixin],
  props: {
    field: {
      type: Object
    },
    parentId: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    },
    model: {
      type: [String, Array, Object, Boolean, Number]
    },
    module: String,
    options: {
      type: Array,
      default: () => []
    },
    callback: {
      type: Object
    },
    datepicker: Object,
    visibleOptionBtn: {
      type: Boolean,
      default: false
    },
    fieldSize: {
      type: String,
      default: 'big'
    },
    width: {
      type: String,
      default: 'unset'
    },
    loading: {
      type: Boolean
    },
    blocked: {
      type: Boolean,
      default: false
    },
    visibilityBlocked: {
      type: Boolean,
      default: false
    },
    newLabel: {
      type: String,
      default: ''
    },
    noRequiredStar: Boolean,
    defaultFirstOption: {
      type: Boolean,
      default: false
    },
    searchParam: {
      type: String,
      default: ''
    },
    parentenum: {
      type: String,
      default: ''
    },
    noTags: Boolean,
    blockedValues: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      FIELD,
      filename_file: [],
      newOptions: [],
      pickerOptions: {
        birth_date: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        date_event: {
          disabledDate(time) {
            // disabled since yesterday
            var date = new Date();
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date;
          },
          showWeekDay: true
        },
        date: {
          disabledDate(time) {
            // disabled since yesterday
            var date = new Date();
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date;
          },
          showWeekDay: true
        }
      },
      fieldValue: [],
      checkSpecializations: [],
      tags: [],
      addFile_loading: false,
      trueValueCheckbox: [],
      sendCheckboxData: [],
      checkOptions: [],
      loadMoreNum: 0,
      defaultKey: 0
    };
  },
  created() {
    this.trueValueCheckbox = Array.from(new Set(this.draftCheckboxData)) || [];
    if (
      (this.field.type == FIELD.TYPE.RELATE ||
        this.field.type == FIELD.TYPE.RELLINK ||
        this.field.subtype == FIELD.TYPE.RELLINK) &&
      this.field.visual_type != FIELD.VISUAL_TYPE.ENUM
    ) {
      if (
        this.options?.length &&
        (this.field.type == FIELD.TYPE.RELLINK ||
          this.field.type == FIELD.TYPE.MULTIENUM)
      ) {
        this.newOptions = this.options;
      } else if (this.options?.length && this.field.type == FIELD.TYPE.RELATE) {
        this.newOptions = this.options;
      }
    }
  },
  mounted() {
    this.trueValueCheckbox = Array.from(new Set(this.draftCheckboxData));

    if (
      (this.form?.work_site == 'rabotaru' ||
        this.form?.work_site == 'superjob') &&
      this.field.value?.length &&
      this.field.name == FIELD.ID.SPECIALIZATIONS &&
      this.field.visual_type == 'sub_checkbox'
    ) {
      const val =
        typeof this.field.value == 'string' && !Array.isArray(this.field.value)
          ? this.field.value.split(/,\s*/g)
          : this.field.value;
      val.forEach(val => {
        const category = val.split('.')[0];
        if (
          this.specializations[category]?.specializations &&
          this.specializations[category]?.specializations[val]
        ) {
          this.tags.push({
            index: val,
            name: this.specializations[category]?.specializations[val]
          });
          this.checkSpecializations.push({
            index: val,
            name: this.specializations[category]?.specializations[val]
          });
          this.sendCheckboxData.push(val);
        }
      });
    }
  },
  computed: {
    blockedOptionsByOtherField() {
      const blockedVals = this.blockedValues
        ? this.blockedValues[this.field.name] || {}
        : {};

      const resultFields = [];
      if (Object.keys(blockedVals).length) {
        const conditionalFields = Object.keys(blockedVals);
        conditionalFields.forEach(field => {
          const hasIdNameValue = this.form[`${field}_id`] || false;
          const conditionalFieldValue = hasIdNameValue
            ? this.form[`${field}_id`]
            : this.form[field];
          if (Object.keys(blockedVals[field]).includes(conditionalFieldValue)) {
            blockedVals[field][conditionalFieldValue].forEach(item => {
              resultFields.push(item);
            });
          }
        });
        return resultFields;
      }
      return [];
    },
    salaryField() {
      return (
        (this.field.type === FIELD.TYPE.DECIMAL ||
          this.field.type === FIELD.TYPE.CURRENCY) &&
        this.field.visual_type !== FIELD.TYPE.DECIMAL
      );
    },

    specializations() {
      return this.field.options;
    },
    areasModel() {
      if (this.field.name != 'areas') return;
      if (
        (typeof this.model === 'string' || typeof this.model === 'number') &&
        this.form?.work_site != 'trudvsem'
      ) {
        return [`${this.model}`];
      } else {
        return this.model;
      }
    },
    filteredOptionsByBlockingParent() {
      const { option_blocking_parent, option_blocker_rules } = this.field;
      const parentVal = this.form[option_blocking_parent];

      return this.options.filter(opt =>
        parentVal && option_blocker_rules[parentVal]
          ? option_blocker_rules[parentVal].includes(opt.id)
          : false
      );
    },
    categoryModel() {
      if (this.field.visual_type == 'sub_radio') {
        let stringModel = String(this.model);
        if (stringModel.slice(0, stringModel.indexOf('.'))) {
          return stringModel.slice(0, stringModel.indexOf('.'));
        } else return '';
      } else if (this.field.visual_type == 'sub_checkbox') {
        let newArray = [];
        for (let item in this.model) {
          if (
            newArray.indexOf(
              this.model[item].slice(0, this.model[item].indexOf('.'))
            ) < 0
          ) {
            newArray.push(
              this.model[item].slice(0, this.model[item].indexOf('.'))
            );
          }
        }
        return newArray;
      } else {
        return '';
      }
    },
    phoneField() {
      return (
        this.field.name == FIELD.ID.PHONE_NUMBER ||
        this.field.name == FIELD.ID.PHONE ||
        this.field.name == FIELD.ID.CONTACTS_PHONES ||
        this.field.name == FIELD.ID.CONTACTS_ADDITIONAL_PHONES ||
        this.field.type == FIELD.ID.PHONE ||
        this.field.name == 'user_phone'
      );
    },
    draftCheckboxData() {
      let draftCheckbox = [];
      if (this.categoryModel) {
        for (let item in this.model) {
          for (let i in this.categoryModel) {
            if (
              typeof this.field.options[this.categoryModel[i]]?.specializations[
                this.model[item]
              ] !== 'undefined' &&
              draftCheckbox.indexOf(
                this.field.options[this.categoryModel[i]]?.specializations[
                  this.model[item]
                ] < 0
              )
            ) {
              draftCheckbox.push(
                this.field.options[this.categoryModel[i]]?.specializations[
                  this.model[item]
                ]
              );
            }
          }
        }
      }
      return draftCheckbox || '';
    },
    specializField() {
      return this.field.name == FIELD.ID.SPECIALIZATIONS;
    },
    timePickerField() {
      return (
        this.field.hasOwnProperty(FIELD.PARAM.VISUAL_TYPE) &&
        this.field[FIELD.PARAM.VISUAL_TYPE] == FIELD.VISUAL_TYPE.TIMEPICKER
      );
    },
    clickSaveForm() {
      return store.state.common.saveFlag;
    },
    trudvsemCity() {
      return store.state.publicator.trudvsemCity || '';
    }
  },
  methods: {
    updateFormData(formData) {
      formData.set('module', MODULE.NOTES);
      if (this.parentId) formData.set('parent_id', this.parentId || '');
      formData.set('action', ACTION.SAVE);
      formData.set('parent_type', this.module);
      formData.set('jsqon_return', 1);
      return formData;
    },
    uploadDocument(file) {
      // можно было бы придумать параметр, когда загрузка файла локальная, до момента сохранения
      if (
        this.field.visual_type != FIELD.VISUAL_TYPE.FILE ||
        !this.field.visual_type
      ) {
        const form = document.getElementById('upload-doc');
        let formData = new FormData(form);
        formData = this.updateFormData(formData);
        this.addFile_loading = true;

        if (file) {
          const { raw: blob, name } =
            Array.isArray(file) && file.length ? file[0] : file;
          formData.set('filename_file', blob, name);

          const params = {
            header: {
              'Content-Type': 'multipart/form-data'
            }
          };

          postController({ options: formData, params })
            .then(() => {
              this.filename_file = [];
              this.$emit('update-documents-list');
            })
            .catch(err =>
              this.catchError(
                err,
                'Возникла ошибка при загрузке документа',
                'upload file'
              )
            )
            .finally(() => {
              this.addFile_loading = false;
            });
        }
      }
    },
    filterOptions(search_string, cb, url) {
      this.fieldValue = [];
      if (this.model && this.model.length) {
        for (let ind = 0; ind < this.model.length; ind++) {
          if (
            (this.newOptions?.length &&
              this.newOptions.find(
                option => option && option.id && option.id === this.model[ind]
              )) ||
            (this.options?.length &&
              this.options.find(
                option => option && option.id === this.model[ind]
              ))
          ) {
            this.fieldValue.push(
              this.newOptions.find(
                option => option && option.id && option.id === this.model[ind]
              ) ||
                this.options.find(
                  option => option && option.id === this.model[ind]
                )
            );
          }
        }
      }
      this.newOptions = [];
      this.newOptions = this.fieldValue;
      this.setNewOptions(search_string, cb, url);
    },
    async setNewOptions(search_string = '', cb, url) {
      const iteration =
        this.newOptions.length <= 0
          ? 0
          : this.newOptions.length - this.fieldValue.length;

      const params = {
        offset: iteration || 0,
        search_string: search_string.trim()
      };

      if (this.field.subtype == FIELD.TYPE.RELLINK) {
        params['getOnlyLabel'] = 1;
      }

      if (this.field.option_blocking_parent) {
        const parentFieldVal = this.form[this.field.option_blocking_parent];
        params['parent_option_blocker'] = parentFieldVal;
      }

      if (this.field.search_param && this.searchParam) {
        params[this.field.search_param] = this.searchParam;
      }

      if (this.field.control_fields) {
        this.field.control_fields.forEach(name => {
          params[`control_fields[${name}]`] =
            this.form[name.split('__')[1]] || this.form[name] || '';
        });
      }

      if (url) {
        let newUrl = '/';
        if (typeof url == 'string') {
          newUrl += url;
        } else {
          const paramMap = {
            email_password: 'email_password',
            email_user: 'email_user',
            mail_sendtype: 'email_protocol',
            port: 'inbound_email_port',
            server_url: 'inbound_email_server_url',
            email_protocol: 'email_protocol'
          };
          for (let key in url) {
            if (url[key]) {
              params[key] =
                key == 'work_site' && url[key] === ''
                  ? this.form[key] || ''
                  : url[key];
            } else {
              const defaultValue = paramMap[key] || key;
              params[key] =
                defaultValue == 'search_string'
                  ? search_string
                  : defaultValue == 'field'
                  ? this.field.name.split('__')[1] || this.field.name
                  : key === 'ssl_enabled'
                  ? (url['type'] === 'inbound_email_mailbox' &&
                      this.form['inbound_email_ssl_enabled'] === '/ssl') ||
                    (url['type'] === 'inbound_email_mailbox_outbound' &&
                      this.form['outbound_email_mail_smtpssl'] === '1') ||
                    this.form['email_protocol'] === 'HTTPS'
                    ? '/ssl'
                    : ''
                  : this.form['email_protocol'] === 'HTTPS' &&
                    key === 'server_url'
                  ? this.form['https_server']
                  : this.form['email_protocol'] === 'HTTPS' && key === 'port'
                  ? '0'
                  : this.form[defaultValue] || '';
            }
          }
        }

        if (
          this.field.name == 'subway_corporate_site' &&
          this.form.city_corporate_site_id
        ) {
          newUrl += `&search_fields[hrpac_cities_id]=${this.form.city_corporate_site_id}`;
        }

        const { data } = await getController({ url: newUrl, params });

        if (!data) return;

        this.loadMoreNum = 0;
        this.checkOptions = [];
        let keyOptions = [];

        if (this.fieldValue && this.fieldValue.length) {
          keyOptions =
            this.model.length == this.fieldValue.length
              ? this.model
              : this.fieldValue.map(val => {
                  val.id;
                });
        }

        if (
          Array.isArray(data) &&
          !data.length &&
          this.field.type == FIELD.TYPE.RELATE
        ) {
          this.newOptions = [];
        } else {
          for (let key in data) {
            this.loadMoreNum++;

            if (typeof data[key] == 'object') {
              if (
                keyOptions.indexOf(data[key].id) == -1 &&
                this.newOptions &&
                (!this.newOptions.find(
                  opt =>
                    opt &&
                    opt.id &&
                    opt.name &&
                    opt.id == data[key].id &&
                    opt.name == this.formatHtml(data[key].name)
                ) ||
                  !this.newOptions.length)
              ) {
                const params = {
                  ...data[key],
                  id: data[key].id,
                  name: this.formatHtml(data[key].name)
                };

                if (data[key].sub_text) {
                  params.sub_text = this.formatHtml(data[key].sub_text);
                }

                this.checkOptions = [...this.checkOptions, params];
              }
            } else if (typeof data[key] == 'string') {
              const value = this.formatHtml(data[key]);

              if (
                keyOptions.indexOf(key) == -1 &&
                this.newOptions &&
                (!this.newOptions.find(
                  opt =>
                    opt &&
                    opt.id &&
                    opt.name &&
                    opt.id == key &&
                    opt.name == value
                ) ||
                  !this.newOptions.length)
              ) {
                this.checkOptions = [
                  ...this.checkOptions,
                  { id: key, name: value }
                ];
              }
            }
          }
        }

        this.newOptions = [...this.newOptions, ...this.checkOptions];

        store.commit('common/setNewOptions', {
          name: this.field.name,
          val: this.newOptions
        });
      }

      if (this.field.visual_type == 'multi-level' && this.newOptions.length) {
        await this.formatTreeLabels(this.newOptions);
      }

      if (cb) cb(this.field, search_string);
      return this.newOptions;
    },
    formatTreeLabels(data) {
      data.forEach(node => {
        if (node.name) {
          node.name = this.formatHtml(node.name);
        }
        if (node.children && node.children.length > 0) {
          this.formatTreeLabels(node.children);
        }
      });
    },
    selectOption(...params) {
      if (this.field.type == FIELD.TYPE.RELATE) {
        this.$emit('change-option', ...params, 'form', this.newOptions);
      } else {
        this.$emit('change-option', ...params);
      }
    },
    changeRellinkOption(...params) {
      if (this.field.type == FIELD.TYPE.RELLINK) {
        this.$emit('change-rellink-option', ...params);
      }
    },
    deleteTag(tag) {
      this.tags = this.tags.filter(e => (e?.index || e) != (tag?.index || tag));
      this.trueValueCheckbox.splice(
        this.trueValueCheckbox.indexOf(tag.name),
        1
      );
      this.sendCheckboxData.splice(this.sendCheckboxData.indexOf(tag.index), 1);
      this.$emit('set-value', FIELD.ID.SPECIALIZATIONS, this.sendCheckboxData);
    },
    deleteDraftTag(tag) {
      const tagData = this.tags.find(t => t.index === tag);
      if (tagData) this.checkSpecial(tagData?.name, tagData?.index, true);
      this.sendCheckboxData = [];
      for (let item in this.model) {
        if (this.model[item] && this.model[item] != tag) {
          this.sendCheckboxData.push(this.model[item]);
        }
      }

      this.tags = this.tags.filter(
        e => (e?.index || e) != (tagData?.index || tag)
      );
      this.$emit('set-value', FIELD.ID.SPECIALIZATIONS, this.sendCheckboxData);
    },
    checkSpecial(name, ind, isDelete = false) {
      if (this.draftCheckboxData.length > 0 && !isDelete) {
        for (let item in this.model) {
          if (
            this.trueValueCheckbox.indexOf(this.draftCheckboxData[item]) < 0
          ) {
            this.trueValueCheckbox.push(this.draftCheckboxData[item]);
          }
          if (
            typeof this.checkSpecializations.find(
              spec => spec.index === this.model[item]
            ) == 'undefined'
          ) {
            this.checkSpecializations.push({
              index: this.model[item],
              name: this.draftCheckboxData[item]
            });
          }
        }
      }
      if (
        this.trueValueCheckbox.indexOf(name) < 0 &&
        this.model.indexOf(name) < 0
      ) {
        let index = ind;
        if (isDelete) {
          this.checkSpecializations.splice(
            this.checkSpecializations.findIndex(({ index }) => index === ind),
            1
          );
          return;
        }
        if (!this.checkSpecializations.find(({ index }) => index === ind)) {
          this.checkSpecializations.push({ name, index });
        }
        if (!this.draftCheckboxData.includes(name))
          this.draftCheckboxData.push(name);
        if (!this.trueValueCheckbox.includes(name))
          this.trueValueCheckbox.push(name);
        this.model = Array.from(new Set([...this.model, index]));
      } else {
        this.trueValueCheckbox.splice(this.trueValueCheckbox.indexOf(name), 1);
        this.checkSpecializations.splice(
          this.checkSpecializations.findIndex(({ index }) => index === ind),
          1
        );
        this.model.splice(this.model.indexOf(ind), 1);
      }
    },
    addSpecial() {
      for (let item in this.checkSpecializations) {
        if (this.tags.length < 5) {
          if (
            !this.tags.some(
              ({ index }) => index == this.checkSpecializations[item].index
            )
          ) {
            this.tags.push(this.checkSpecializations[item]);
          }
          if (
            !this.sendCheckboxData.includes(
              this.checkSpecializations[item].index
            )
          ) {
            this.sendCheckboxData.push(this.checkSpecializations[item].index);
          }
        }
      }

      this.$emit('set-value', FIELD.ID.SPECIALIZATIONS, this.sendCheckboxData);
      this.checkSpecializations = [];
    },
    addDraftSpecial() {
      this.sendCheckboxData = [];
      if (this.checkSpecializations.length <= 5) {
        for (let item in this.checkSpecializations) {
          this.sendCheckboxData.push(this.checkSpecializations[item].index);
        }
      }

      this.$emit('set-value', FIELD.ID.SPECIALIZATIONS, this.sendCheckboxData);
      this.checkSpecializations = [];
    },
    setValue(name, val, blocked, trigger) {
      if (
        name == FIELD.ID.SPECIALIZATIONS &&
        (this.field.visual_type == 'sub_checkbox' ||
          this.field.visual_type == 'sub_radio')
      ) {
        this.fieldValue = val;
        if (this.tags) {
          let newValue = [];

          for (let item in this.tags) {
            for (let i in this.trueValueCheckbox) {
              if (this.tags[item].name == this.trueValueCheckbox[i]) {
                newValue.push(this.trueValueCheckbox[i]);
              }
            }
          }
          if (this.field.visual_type == 'sub_radio') {
            this.trueValueCheckbox = newValue;
          }
        } else {
          if (this.field.visual_type == 'sub_radio') {
            this.trueValueCheckbox = [];
            this.checkSpecializations = [];
          }
        }
      } else {
        this.$emit('set-value', name, val, blocked, trigger);
        if (
          (name == 'outbound_email_email_provider_chooser' &&
            val == 'Другое') ||
          (name == 'outbound_email_email_provider_chooser' &&
            val == 'Microsoft Exchange')
        ) {
          this.$emit('set-value', 'inbound_email_server_url', '', '');
          this.$emit('set-value', 'outbound_email_mail_smtpserver', '', '');
        }
        if (
          name == 'email_protocol' ||
          name == 'outbound_email_email_provider_chooser'
        ) {
          if (this.form['email_protocol'] == 'SMTP/IMAP') {
            if (
              this.form['outbound_email_email_provider_chooser'] == 'Yandex' ||
              this.form['outbound_email_email_provider_chooser'] == 'Mail' ||
              this.form['outbound_email_email_provider_chooser'] ==
                'Microsoft Exchange'
            ) {
              this.$emit('set-value', 'outbound_email_mail_smtpssl', '1', '');
              this.$emit('set-value', 'inbound_email_port', '993', '');
              this.$emit(
                'set-value',
                'outbound_email_mail_smtpport',
                '465',
                ''
              );
              this.$emit('set-value', 'inbound_email_ssl_enabled', '/ssl', '');
            } else if (
              this.form['outbound_email_email_provider_chooser'] == 'Gmail'
            ) {
              this.$emit('set-value', 'outbound_email_mail_smtpssl', '2', '');
              this.$emit('set-value', 'inbound_email_port', '993', '');
              this.$emit('set-value', 'inbound_email_ssl_enabled', '/ssl', '');
              this.$emit(
                'set-value',
                'outbound_email_mail_smtpport',
                '587',
                ''
              );
            }

            if (
              this.form['outbound_email_email_provider_chooser'] == 'Gmail' ||
              this.form['outbound_email_email_provider_chooser'] == 'Yandex' ||
              this.form['outbound_email_email_provider_chooser'] == 'Mail'
            ) {
              this.$emit(
                'set-value',
                'outbound_email_mail_smtpserver',
                `smtp.${this.form[
                  'outbound_email_email_provider_chooser'
                ].toLowerCase()}.${
                  this.form['outbound_email_email_provider_chooser'] == 'Gmail'
                    ? 'com'
                    : 'ru'
                }`,
                ''
              );

              this.$emit(
                'set-value',
                'inbound_email_server_url',
                `imap.${this.form[
                  'outbound_email_email_provider_chooser'
                ].toLowerCase()}.${
                  this.form['outbound_email_email_provider_chooser'] == 'Gmail'
                    ? 'com'
                    : 'ru'
                }`,
                ''
              );
            }
          }
        }
      }

      if (
        val &&
        this.callback?.field &&
        this.field.visual_type === 'radiobutton'
      ) {
        this.callback.field.change(this.field, val, this.field.blocked, true);
      }
    },
    setRadioValue(name, val) {
      this.$emit('set-value', name, val, this.field.blocked);
    },
    addNewOption(name) {
      this.$emit('add-new-option', name);
    }
  },
  watch: {
    options: {
      handler: function () {
        if (
          (this.field.type == FIELD.TYPE.RELATE ||
            this.field.type == FIELD.TYPE.RELLINK) &&
          this.options.some(opt => !!opt.id) // tfc-45, при выборе опции заменялось на опцию-пустышку
        ) {
          this.newOptions =
            store.state.common.newOptions[this.field.name] &&
            store.state.common.newOptions[this.field.name].length
              ? [
                  ...store.state.common.newOptions[this.field.name],
                  ...this.options
                ]
              : this.options;
          const set = new Set(this.newOptions.map(JSON.stringify));

          this.newOptions = Array.from(set).map(JSON.parse);
        }
      },
      deep: true
    }
  },
  components: {
    'el-form-item': FormItem,
    DatePicker,
    TimePicker,
    Dropdown,
    MultiLevelSelect,
    Input,
    InputMasked,
    CustomCheckbox,
    Radio,
    Switcher,
    Button,
    Tag,
    CheckboxGroup,
    Upload,
    CustomCheckboxGroup,
    Alert,
    Tooltip,
    Icon,
    Link
  }
};
</script>
<style lang="scss" scoped>
.with-background {
  padding: 20px;
  border-radius: 4px;

  .el-form-item__content {
    .el-form-item__label {
      overflow: unset !important;
      white-space: normal !important;
      margin-bottom: 16px;
      margin-right: 0 !important;
      line-height: 24px !important;
    }
  }
}

.radio-group {
  white-space: normal !important;
  line-height: unset !important;
  height: auto !important;
  align-items: start;
}

.el-checkbox-group {
  background: $grey10;
  border-radius: 4px;
  padding: 12px;
  overflow-x: hidden;
}

.currency__input {
  width: 128px;

  & ::v-deep .el-form-item {
    width: auto !important;
  }
}

.stringText {
  color: $grey100;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  margin-bottom: 12px;
}

.form {
  &__upload {
    width: 100%;
    max-width: 448px;
  }

  &-format {
    margin-top: 20px;
    display: grid;
    flex-direction: column;
    width: inherit;
    gap: 12px;

    &__title {
      color: $grey40;
      line-height: 20px;
      font-weight: 700;
    }

    &__radio {
      display: grid;
      gap: 16px;

      &-text {
        & > .el-form-radio__label {
          color: $grey80;
        }
      }
    }
  }
}

.el-form-item ::v-deep {
  .el-upload-dragger {
    min-height: 136px !important;
  }

  .specializations-tags {
    line-height: 0;
    margin-top: 12px;

    .el-tag {
      margin: 0 8px 8px 0;
    }
  }

  .specializations-block {
    background: $black-10;
    border-radius: 4px;
    margin-top: 12px;
    padding: 12px;

    > div {
      .spec-checkbox {
        margin-bottom: 12px;
        max-height: unset;
        display: inline-flex;
        column-count: 2;
        width: 100%;
        align-content: start;

        .el-checkbox__label {
          white-space: normal;
          word-break: break-word;
        }
      }

      .el-radio {
        margin-bottom: 12px;
        margin-right: 0;
        width: 100%;
        height: auto;
        display: inline-flex;

        .el-radio__label {
          font-size: 16px;
          padding-left: 10px;
          white-space: break-spaces;
          line-height: 20px;
          word-break: normal;
        }
      }
    }

    button {
      margin-top: 12px;
    }
  }

  &__content {
    & ::v-deep .el-checkbox {
      // margin-top: 30px;

      &__label {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  &__label {
    color: $black-200;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    display: flex;

    .help__text {
      display: inline;
      color: $black-80;
      margin-left: 4px;
    }
  }

  .required-star {
    display: inline;
    color: $red;
  }

  .rabota-ru-lbl {
    padding: 12px 16px;
    border-radius: 4px;
    background-color: $yellow16;
    font-size: 16px;
    line-height: 24px;
    color: $grey80;
    word-break: break-word;

    svg {
      margin-right: 8px;
    }
  }
}
</style>

<style lang="scss">
.el-form-item {
  width: auto;
}

.currency__input {
  width: 128px;

  .el-form-item {
    width: auto;
  }
}

.radio__block {
  display: flex;

  .el-form-item__content {
    width: fit-content !important;
    display: flex;
    flex-direction: column !important;

    .el-form-item__label {
      display: none;
    }

    .el-radio {
      width: fit-content;
    }
  }
}

.column-radio__block {
  text-align: left;
  align-items: flex-start;

  .el-form-item__content {
    width: 100%;
    display: flex;
    flex-direction: column !important;

    .el-form-item__label {
      display: none;
    }

    .el-radio {
      margin-bottom: 12px;

      &__label {
        font-size: 14px;
        line-height: 24px;
      }
    }

    .el-radio:last-child {
      margin-bottom: 4px;
    }
  }
}

a.hyperlink.help__text:hover span,
p.help__text:hover span {
  color: inherit !important;
}
</style>
